export class DsarRetrievalSettings {
  constructor() {
    let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const defaults = {
      align: 'center',
      width: {
        type: '%',
        value: 100
      },
      height: {
        type: '%',
        value: 100
      },
      padding: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      },
      border: {
        borderWidth: 0,
        borderColor: '#000000',
        borderStyle: 'solid'
      },
      background: '#ffffff',
      closeFont: {
        fontSize: 16,
        color: '#999999',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      defaultLanguage: 'EN',
      useBrowserDefault: false
    };
    Object.assign(this, defaults, overrides);
  }
}
;
export const DsarRetrievalTypes = {
  language: {
    language: {
      title: 'Default Language',
      type: 'Language'
    },
    useBrowserDefault: {
      title: 'Use Browser Default',
      type: 'Switch'
    }
  },
  settings: {
    url: {
      title: 'Website BG',
      type: 'Input'
    }
  },
  orientation: {
    width: {
      title: 'Width',
      type: 'Size'
    },
    height: {
      title: 'Height',
      type: 'Size'
    },
    padding: {
      title: 'Padding',
      type: 'Padding'
    }
  },
  styles: {
    background: {
      title: 'Background Color',
      type: 'ColorPicker'
    },
    border: {
      title: 'Border',
      type: 'Border'
    }
  }
};